const CSRF_LOG_PREFIX = "[GET - CSRF]";
const USER_LOG_PREFIX = "[GET - User]";
const SUPPORT_API_LOG_PREFIX = "[Support API]";

const DEFAULT_HEADERS = {
  "Content-type": "application/json",
};

const supportNotificationRequest = {
  preferredContactMethod: {
    Sms: "sms",
  } as const,
};

export {
  CSRF_LOG_PREFIX,
  DEFAULT_HEADERS,
  SUPPORT_API_LOG_PREFIX,
  USER_LOG_PREFIX,
  supportNotificationRequest,
};
